import { type App } from 'vue'
import AppButton from './app-button.vue'
import AppErrorMsg from './app-error-msg.vue'
import AppInput from './app-input.vue'
import AppInputNumber from './app-input-number.vue'
import AppInputPin from './app-input-pin.vue'
import AppNotice from './app-notice.vue'
import AppRouterView from './app-router-view.vue'
import AppSelect from './app-select.vue'
import AppSubmit from './app-submit.vue'
import AppTable from './app-table.vue'
import FaIcon from './fa-icon.vue'
import Modal from './modal'

export default {
  install (app: App) {
    app.component('AppButton', AppButton)
    app.component('AppErrorMsg', AppErrorMsg)
    app.component('AppInput', AppInput)
    app.component('AppInputNumber', AppInputNumber)
    app.component('AppInputPin', AppInputPin)
    app.component('AppNotice', AppNotice)
    app.component('AppRouterView', AppRouterView)
    app.component('AppSelect', AppSelect)
    app.component('AppSubmit', AppSubmit)
    app.component('AppTable', AppTable)
    app.component('FaIcon', FaIcon)
    app.use(Modal)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppButton: typeof AppButton,
    AppErrorMsg: typeof AppErrorMsg,
    AppInput: typeof AppInput,
    AppInputNumber: typeof AppInputNumber,
    AppInputPin: typeof AppInputPin,
    AppNotice: typeof AppNotice,
    AppRouterView: typeof AppRouterView,
    AppSelect: typeof AppSelect,
    AppSubmit: typeof AppSubmit,
    AppTable: typeof AppTable,
    FaIcon: typeof FaIcon,
  }
}
